import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Container } from '@mui/material';
import useLocales from 'hooks/useLocales';
import Image from 'components/image/Image';
import { useTenantInfo } from 'hooks/useTenantInfo';

import './Index.scss';

const Error500 = () => {
  const { t } = useLocales();
  const { tenantLogo } = useTenantInfo();

  return (
    <div className="server-error-page__container">
      <div className="server-error-page__card">
        <div className="server-error-page__card-content">
          <div className="server-error-page__logo">
            {tenantLogo ? (
                <Image url={tenantLogo} width={180} height={80} />
            ) : (
              <Image name="new-rec-logos.svg" width={60} height={60} />
            )}
          </div>
          
          <h1 className="server-error-page__title">
            {t('Internal Server Error')}
          </h1>
          
          <p className="server-error-page__message">
            {t("Something went wrong on our end. Please try again later. If the problem persists, contact support.")}
          </p>

          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            size="large"
            className="server-error-page__button"
          >
            {t('Go to Home')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Error500;
